module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v ajust-order"
  }, [_c('div', {
    staticClass: "href-content t-content"
  }, [_c('div', {
    staticClass: "left-content search-form"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.todayStr,
      "actions": _vm.actions_search
    },
    on: {
      "clickMenu": _vm.clickMenuS
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "油品"
    },
    model: {
      value: (_vm.oilType),
      callback: function($$v) {
        _vm.oilType = $$v
      },
      expression: "oilType"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "油库"
    },
    model: {
      value: (_vm.team),
      callback: function($$v) {
        _vm.team = $$v
      },
      expression: "team"
    }
  }, _vm._l((_vm.carTeams), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _c('a', {
    staticClass: "adjust-btn",
    staticStyle: {
      "background-color": "#0b5591",
      "color": "#fff"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.addYaohuoToplan
    }
  }, [_vm._v("要货定单加入计划中")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.boardings),
      callback: function($$v) {
        _vm.boardings = $$v
      },
      expression: "boardings"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "no_delivery"
    }
  }, [_vm._v("未上车")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "delivery"
    }
  }, [_vm._v("已上车")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("要货")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": '显示要货',
      "inactive-text": '不显示要货'
    },
    model: {
      value: (_vm.yaoHuoBJ),
      callback: function($$v) {
        _vm.yaoHuoBJ = $$v
      },
      expression: "yaoHuoBJ"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("全部车辆")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": '全部车辆',
      "inactive-text": '车队筛选'
    },
    model: {
      value: (_vm.allCar),
      callback: function($$v) {
        _vm.allCar = $$v
      },
      expression: "allCar"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-content-1",
    staticStyle: {
      "margin-right": "0.7rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": '计划：' + _vm.chooseOrderCg.length,
      "actions": _vm.actions3
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.chooseOrderCg,
      "table_style": 1,
      "ths": _vm.jhOrderListThs,
      "table_actions": _vm.tableActionOrder3,
      "lineQF": true
    },
    on: {
      "click_row": _vm.clickOrderRow,
      "clickTdBtn": _vm.clickOrderTdBtnSD
    }
  }), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": '锁定：' + _vm.chooseOrders.length,
      "actions": _vm.actions
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('mii-base-table', {
    attrs: {
      "datas": _vm.chooseOrders,
      "table_style": 1,
      "ths": _vm.jhOrderListThs,
      "table_actions": _vm.tableActionOrder2,
      "lineQF": true
    },
    on: {
      "click_row": _vm.clickOrderRow,
      "clickTdBtn": _vm.clickOrderTdBtn
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.orderLoading),
      expression: "orderLoading"
    }],
    staticClass: "right-content-1-2"
  }, [_c('content-title', {
    attrs: {
      "title": '订单：' + _vm.showOrderList.length,
      "actions": _vm.actions2,
      "searchInput": true,
      "clearNum": _vm.clearNum
    },
    on: {
      "clickMenu": _vm.clickMenu,
      "searchInputChange": _vm.searchInputChange1
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showOrderList,
      "table_style": 2,
      "ths": _vm.allOrderListThs,
      "table_actions": _vm.tableActionOrder,
      "lineQF": true,
      "show_dian": true,
      "lineSuo": 'SFID',
      "chooseRowValue": _vm.chooseOrderValue,
      "chooseAction": {
        action: 'clickTdBtn',
        key: 'oil_detail'
      }
    },
    on: {
      "click_row": _vm.chooseThisOrder,
      "clickTdBtn": _vm.clickOrderTdBtn,
      "click_row_data": _vm.clickRowData
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "href-content",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carLoading),
      expression: "carLoading"
    }],
    staticClass: "left-content"
  }, [_c('content-title', {
    attrs: {
      "title": '车辆：' + _vm.carList.length,
      "searchInput": true,
      "clearNum": _vm.clearNum + _vm.clearNumZd
    },
    on: {
      "searchInputChange": _vm.searchInputChange2
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showCarList,
      "table_style": 2,
      "ths": _vm.carListThs,
      "table_actions": _vm.tableActionCar,
      "lineSuo": '车牌号',
      "chooseRowValue": _vm.chooseCarValue,
      "chooseAction": {
        action: 'click_row'
      }
    },
    on: {
      "click_row": _vm.clickCarRow,
      "clickTdBtn": _vm.clickOrderTdBtn
    }
  })], 1)], 1), _vm._v(" "), (_vm.showCarOrderType === 'car') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [(_vm.chooseCar && !_vm.chooseCar.dc) ? _c('div', {
    staticClass: "static-content-div"
  }, [(_vm.chooseCar['前仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '前仓：' + _vm.chooseCar['前仓']
    },
    model: {
      value: (_vm.chooseOrder1),
      callback: function($$v) {
        _vm.chooseOrder1 = $$v
      },
      expression: "chooseOrder1"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index),
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.chooseCar['中仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '中仓：' + _vm.chooseCar['中仓']
    },
    model: {
      value: (_vm.chooseOrder2),
      callback: function($$v) {
        _vm.chooseOrder2 = $$v
      },
      expression: "chooseOrder2"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index) + '_1',
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.chooseCar['后仓']) ? _c('div', {
    staticClass: "one-input select-order"
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "size": "mini",
      "filterable": "",
      "placeholder": '后仓：' + _vm.chooseCar['后仓']
    },
    model: {
      value: (_vm.chooseOrder3),
      callback: function($$v) {
        _vm.chooseOrder3 = $$v
      },
      expression: "chooseOrder3"
    }
  }, _vm._l((_vm.canChooseOrders), function(item, index) {
    return _c('el-option', {
      key: item.SFID + String(index) + '_2',
      staticStyle: {
        "max-width": "30rem"
      },
      attrs: {
        "label": item.SFID + '：' + item.加油站名称 + ' --- ' + item.油品名称 + ' --- ' + item.断货时间 + ' --- ' + item.建议配送量 + ' ------------------------------------------------- ' + item.DXCHART,
        "value": item.SFID
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "adjust-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.saveCarOrderDuo
    }
  }, [_vm._v("保存")])]) : _vm._e(), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": (_vm.chooseCar ? _vm.chooseCar['车牌号'] : '') + (_vm.chooseOrder ? ' >> ' + _vm.chooseOrder['油站名'] : ''),
      "actions": _vm.actions4
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showCarOrderList,
      "table_style": 1,
      "table_actions": _vm.tableAction,
      "ths": _vm.carOrderListThs,
      "realAction": true
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCarOrderType === 'oil') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.carOrderTitle,
      "actions": _vm.actions4
    },
    on: {
      "clickMenu": _vm.clickMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.showOilCarOrderList,
      "table_style": 1,
      "table_actions": _vm.tableActionOil,
      "ths": _vm.carOrderListThsOil,
      "realAction": true
    },
    on: {
      "click_row_data": _vm.clickRowDataCarOrder,
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showCarOrderType === 'jxc') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.carOrderLoading),
      expression: "carOrderLoading"
    }],
    staticClass: "right-content-2 static-content"
  }, [_c('content-title', {
    attrs: {
      "title": _vm.jxcTitle + ' >> 进销存'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "flex": "1"
    }
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.jxcDatas,
      "table_style": 1,
      "ths": _vm.jxcThs
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseOrderChangeDepot['加油站名称'] + ' >>> 订单油库变更',
      "visible": _vm.showChooseDepot,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChooseDepot = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("选择油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.chooseOrderChangeDepot['油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.chooseOrderChangeDepot, '油库代码', $$v)
      },
      expression: "chooseOrderChangeDepot['油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChooseDepot = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChangeOrderDepot
    }
  }, [_vm._v("保存修改")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCarOrder ? (_vm.chooseCarOrder['加油站名称'] + ' >>> 配送单油库变更') : '',
      "visible": _vm.showChooseDepotPs,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showChooseDepotPs = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#666",
      "margin-right": "0.5rem",
      "line-height": "2rem"
    }
  }, [_vm._v("整车调整")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.allCarOrder),
      callback: function($$v) {
        _vm.allCarOrder = $$v
      },
      expression: "allCarOrder"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'only'
    }
  }, [_vm._v("该运单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'tang'
    }
  }, [_vm._v("本趟次")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'dayCar'
    }
  }, [_vm._v("全车")])], 1)], 1), _vm._v(" "), (_vm.chooseCarOrder) ? _c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("选择油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.psDepot),
      callback: function($$v) {
        _vm.psDepot = $$v
      },
      expression: "psDepot"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChooseDepotPs = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChangePsDepot
    }
  }, [_vm._v("保存修改")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCar ? _vm.chooseCar['车牌号'] : '',
      "visible": _vm.showCarDetail
    },
    on: {
      "update:visible": function($event) {
        _vm.showCarDetail = $event
      }
    }
  }, [(_vm.chooseCar) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.chooseCar['前仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('前仓-' + this.chooseCar['前仓']))])]) : _vm._e(), _vm._v(" "), (_vm.chooseCar['中仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('中仓-' + this.chooseCar['中仓']))])]) : _vm._e(), _vm._v(" "), (_vm.chooseCar['后仓']) ? _c('div', {
    staticClass: "one-input",
    staticStyle: {
      "display": "flex",
      "margin-top": "1rem",
      "align-items": "center",
      "flex": "1"
    }
  }, [_c('span', [_vm._v(_vm._s('后仓-' + this.chooseCar['后仓']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.carDetail['xzData']), function(item, key) {
    return (item && key !== '车牌号') ? _c('div', {
      staticClass: "one-input",
      staticStyle: {
        "display": "flex",
        "margin-top": "1rem",
        "align-items": "center",
        "flex": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(key + '-' + item))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.carDetail['psData'].length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": "近三天配送记录"
    }
  }), _vm._v(" "), _c('mii-base-table', {
    attrs: {
      "datas": _vm.carDetail['psData'],
      "table_style": 2,
      "ths": _vm.psjlThs,
      "lineQF": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showCarDetail = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseOrderChangeDepot['加油站名称'] + ' >>> 订单拆分',
      "visible": _vm.showSplitOrder,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showSplitOrder = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("拆单数")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择拆单数"
    },
    model: {
      value: (_vm.splitNum),
      callback: function($$v) {
        _vm.splitNum = $$v
      },
      expression: "splitNum"
    }
  }, _vm._l(([2, 3, 4, 5, 6, 7, 8, 9, 10]), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.splitOrderData), function(item, index) {
    return (item && !(Number(index) > _vm.splitNum)) ? _c('div', {
      staticClass: "one-input",
      staticStyle: {
        "display": "flex",
        "margin-top": "1rem",
        "align-items": "center",
        "width": "50%"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "3rem"
      }
    }, [_vm._v(_vm._s('新单' + index))]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "7rem"
      },
      attrs: {
        "size": "small",
        "placeholder": "请输入"
      },
      model: {
        value: (_vm.splitOrderData[index]),
        callback: function($$v) {
          _vm.$set(_vm.splitOrderData, index, $$v)
        },
        expression: "splitOrderData[index]"
      }
    })], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSplitOrder = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveSplitOrder
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.chooseCarOrder && _vm.chooseCarOrder ? _vm.chooseCarOrder['车牌号'] + '  >>> ' + _vm.chooseCarOrder['加油站名称'] + ' >>> 趟次调整' : '',
      "visible": _vm.showTctz,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showTctz = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("趟次调整")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择趟次"
    },
    model: {
      value: (_vm.tc),
      callback: function($$v) {
        _vm.tc = $$v
      },
      expression: "tc"
    }
  }, _vm._l((_vm.tcList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showTctz = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTctz
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统提示",
      "visible": _vm.showAddTs,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAddTs = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("配送单还未保存，是否确认切换")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTsAction('back')
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTsAction('change')
      }
    }
  }, [_vm._v("切换")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addTsAction('sc')
      }
    }
  }, [_vm._v("保存并切换")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "运单导出",
      "visible": _vm.showOutput
    },
    on: {
      "update:visible": function($event) {
        _vm.showOutput = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.outPutOilType),
      callback: function($$v) {
        _vm.outPutOilType = $$v
      },
      expression: "outPutOilType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "汽油"
    }
  }, [_vm._v("汽油")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "柴油"
    }
  }, [_vm._v("柴油")])], 1), _vm._v(" "), [_c('content-title', {
    attrs: {
      "title": '总单数:' + _vm.orderCar.length
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.orderTj,
      "columns": _vm.orderTjThs,
      "mergeRowKeyList": ['油库名称', '油品名称', 'DEPOT_TOTAL', 'DEPOT_TOTAL_L']
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showOutput = false
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.orderCar.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.outputPsDatas
    }
  }, [_vm._v("导出")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "要货概览",
      "visible": _vm.showYaohuo
    },
    on: {
      "update:visible": function($event) {
        _vm.showYaohuo = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin": "0 1rem 1rem",
      "display": "flex !important"
    },
    model: {
      value: (_vm.yaoHuoOilType),
      callback: function($$v) {
        _vm.yaoHuoOilType = $$v
      },
      expression: "yaoHuoOilType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "汽油"
    }
  }, [_vm._v("汽油")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "柴油"
    }
  }, [_vm._v("柴油")])], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "7rem"
    },
    attrs: {
      "size": "mini",
      "placeholder": "最小要货差值"
    },
    model: {
      value: (_vm.yaoHuoMin),
      callback: function($$v) {
        _vm.yaoHuoMin = $$v
      },
      expression: "yaoHuoMin"
    }
  })], 1), _vm._v(" "), [_c('content-title', {
    attrs: {
      "title": '要货量',
      "searchInput": true,
      "clearNum": _vm.clearNum
    },
    on: {
      "searchInputChange": _vm.searchInputChange3
    }
  }), _vm._v(" "), _c('mii-table-oil', {
    attrs: {
      "datas": _vm.showYaoHuoCheckList,
      "columns": _vm.yaohuoThs,
      "mergeRowKeyList": ['加油站名称', '油品名称', '要货量', 'TOTAL_PS', '差值']
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showYaohuo = false
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.oilDetailMap['加油站名称'],
      "visible": _vm.showOilDetail,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showOilDetail = $event
      }
    }
  }, [_c('oil-ps-detail'), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showOilDetail = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.selectArea,
      "visible": _vm.showAreaJxc,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAreaJxc = $event
      }
    }
  }, [_c('area-jxc'), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAreaJxc = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增运送订单",
      "visible": _vm.showAdd,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form case-form-gas"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.chooseGIndex),
      callback: function($$v) {
        _vm.chooseGIndex = $$v
      },
      expression: "chooseGIndex"
    }
  }, _vm._l((_vm.gasDatas), function(item, index) {
    return _c('el-option', {
      key: item['代号'] + index,
      staticStyle: {
        "max-width": "27rem"
      },
      attrs: {
        "label": item['加油站名称'] + '-' + item['罐号'] + '罐' + '-' + item['油品名称'] + '--------------------------' + item['DXCHART'],
        "value": index
      }
    })
  }))], 1), _vm._v(" "), (_vm.chooseG && _vm.chooseG.油站代码) ? _c('div', {
    staticClass: "case-form case-form-gas"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("加油站")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.加油站名称),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "加油站名称", $$v)
      },
      expression: "chooseG.加油站名称"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("罐号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.罐号),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "罐号", $$v)
      },
      expression: "chooseG.罐号"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("油品")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.chooseG.油品名称),
      callback: function($$v) {
        _vm.$set(_vm.chooseG, "油品名称", $$v)
      },
      expression: "chooseG.油品名称"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("期初库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newOrder.期初库存),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "期初库存", $$v)
      },
      expression: "newOrder.期初库存"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("入库升数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.newOrder.入库升数),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "入库升数", $$v)
      },
      expression: "newOrder.入库升数"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("出库升数")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.inputCKSS),
      callback: function($$v) {
        _vm.inputCKSS = $$v
      },
      expression: "inputCKSS"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("期末库存")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.期末库存),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "期末库存", $$v)
      },
      expression: "newOrder.期末库存"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("空容")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.空容),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "空容", $$v)
      },
      expression: "newOrder.空容"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("断货时间")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder.断货时间),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, "断货时间", $$v)
      },
      expression: "newOrder.断货时间"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("订单紧急程度")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['订单紧急程度']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '订单紧急程度', $$v)
      },
      expression: "newOrder['订单紧急程度']"
    }
  }, _vm._l((['可配送订单', '紧急订单', '库存充足订单']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("小罐多销")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['小罐多销']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '小罐多销', $$v)
      },
      expression: "newOrder['小罐多销']"
    }
  }, _vm._l(([{
    label: '是',
    key: 1
  }, {
    label: '不是',
    key: 0
  }]), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("配送油库")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.newOrder['油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '油库代码', $$v)
      },
      expression: "newOrder['油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("建议配送量")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.inputPSL),
      callback: function($$v) {
        _vm.inputPSL = $$v
      },
      expression: "inputPSL"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("不容纳时间")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "disabled": true,
      "size": "small",
      "placeholder": ""
    },
    model: {
      value: (_vm.newOrder['不容纳时间']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '不容纳时间', $$v)
      },
      expression: "newOrder['不容纳时间']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("当日加单")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.newOrder['当日加单']),
      callback: function($$v) {
        _vm.$set(_vm.newOrder, '当日加单', $$v)
      },
      expression: "newOrder['当日加单']"
    }
  }, _vm._l(([{
    label: '是',
    key: 1
  }, {
    label: '不是',
    key: 0
  }]), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveGasOrder
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2238b415","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/adjust_order.vue
// module id = 963
// module chunks = 1